<template>
	<div class="pop-box">
		<div class="pop-head">
			<h3 class="title">帮助</h3>
			<svg-icon style="color: #72767b;font-size: 12px;font-weight: 400;cursor: pointer;" icon-class="close" @click="close()"/>
		</div>
		<div class="popContent">
			<div>
				<div class="pop-title">使用手册</div>
				<div class="pop-p">欢迎在以下地址查看我们的产品使用详情：</div>
				<el-link href="https://majorel.yuque.com/docs/share/74b23fb1-ab82-4275-aaaf-6ae2bce71337" target="_blank" type="primary">《OCS+2.0使用手册》</el-link>
			</div>


			<div>
				<div class="pop-title">版本信息</div>
				<div class="pop-v">当前版本 <big>{{version.version}}</big>
				<span class="version_time">{{version.create_time}}</span></div>
				<div class="pop-p" style="white-space: pre-line;" v-html="version.remark"></div>
				<div style="display: flex; justify-content: flex-end; height: 1em;">
					<el-button type="text" v-if="versionHistory.length>0" @click="linkToVersions" style="text-align: right;">{{showHistory?`隐藏`:`更多`}}</el-button>
				</div>
			</div>
			<div v-if="showHistory">
				<el-divider></el-divider>
				<!-- <div class="pop-title">历史版本信息</div> -->
				<template v-for="(data,index) in versionHistory">
					<el-divider v-if="index"></el-divider>
					<div class="pop-v"> <big>{{data.version}}</big></div>
					<div class="pop-p">{{data.remark}}</div>
				</template>
			</div>

		</div>
	</div>
</template>
<script>
export default {
	name: 'Help',
	data() {
		return {
			showHistory: false,
			version: {
			},
			versionHistory: []
		}
	},
	methods: {
		requestVersionHistory(){
			this.$api.ocsGetVersionHistory().then(res=>{
				if(res && res.errcode == 0){
					this.version = res.data[0];
					this.versionHistory = res.data.slice(1);
				}
			})
		},
		close(){
			this.$emit("close");
		},
		linkToVersions(){
			this.$router.push("/versions/index");
			this.close();
		}
	}
}
</script>
<style lang="scss" scoped>
.pop-box{
	line-height: initial;
	width: 100%;

	& > .pop-head{
		height: 50px;
		font-size: 18px;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: rgb(247, 247, 247);

		& .title{
			font-size: 24px;
			font-weight: 500;
			color: #337EFF;
			line-height: 58px;
		}
	}

	& > .popContent{
		height: calc(100vh - 50px);
		overflow-y: auto;
		overflow-x: hidden;
		padding: 25px;
		box-sizing: border-box;

		& > div {
			margin-bottom: 30px;
			& > .pop-title{
				font-size: 16px;
				font-weight: bold;
				color: #3C4353;
				line-height: 22px;
				margin-bottom: 16px;
			}

			& > .pop-p{
				font-size: 14px;
				font-weight: 400;
				color: #838A9D;
				line-height: 22px;
			}

			& > .pop-v {
				font-size: 14px;
				font-weight: 400;
				color: #3C4353;
				line-height: 22px;

				& > big {
					color: #337EFF;
				}
			}
		}
	}
}
.version_time {
	color: gray;
	margin-left: 1em;
}
</style>